import ChannelAttributes from "./ChannelAttributes";

export default ChannelAttributes;
